import React from 'react';
import { T_LeadsNature } from 'types/app.type';

import { LeadsNurture } from '@/components/ui/leads-nature/LeadsNurture';
import { useLeadsNurture } from '@/hooks/useLeadsNurture';

interface Props {
  apiEndpoint: string;
  isSignedIn?: boolean;
}

export const LeadManager = ({ apiEndpoint, isSignedIn = false }: Props) => {
  const { bottomLeads, activePopup, dismissLead } = useLeadsNurture({
    apiEndpoint,
    isSignedIn,
  });
  return (
    <>
      {bottomLeads.map((lead: T_LeadsNature) => (
        <LeadsNurture key={lead.id} leadContent={lead} dismissAction={() => null} />
      ))}

      {activePopup && (
        // <div className="pointer-events-none fixed left-0 right-0 top-0 z-50 flex flex-col items-center">
        <LeadsNurture
          key={activePopup.id}
          leadContent={activePopup}
          dismissAction={() => dismissLead(activePopup)}
        />
        // </div>
      )}
    </>
  );
};
